import i18n from '@/common/plugins/i18n'
import Vue from 'vue'
import Vuetify from 'vuetify'
// Choose from https://www.materialui.co/colors
Vue.use(Vuetify)

const options = {
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    themes: {
      light: {
        primary: process.env.APP_COLOR,
        secondary: process.env.APP_SECONDARY_COLOR,
        info: process.env.APP_INFO_COLOR,
        accent: process.env.APP_ACCENT_COLOR,
        warning: '#FFA000', // Amber 700
        error: '#f44336', // Red 500
        success: '#4CAF50', // Green 500
        'app-append': '#00897B', // Teal 600
        'app-edit': '#FFA726', // Orange 400
        'app-remove': '#ef5350' // Red 400
      }
    }
  },
  icons: {
    iconfont: 'mdiSvg' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  }
}

export default new Vuetify(options)



// WEBPACK FOOTER //
// ./src/common/plugins/vuetify.js